// app/javascript/controllers/slideover_trigger_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    id: String, // slideover element id
    url: String, // optional dynamic URL to load into the slideover
    reset: { type: Boolean, default: true }, // force reload even if same URL
  };

  open() {
    const el = document.getElementById(this.idValue);
    if (!el) return;
    el.dispatchEvent(
      new CustomEvent("slideover:open", {
        bubbles: true,
        detail: {
          src: this.hasUrlValue ? this.urlValue : null,
          reset: this.resetValue,
        },
      }),
    );
  }

  close() {
    const el = document.getElementById(this.idValue);
    if (el) el.dispatchEvent(new CustomEvent("slideover:close", { bubbles: true }));
  }
}
